const basePath = process.env.REACT_APP_BASE_PATH;

export function getPath(page, params) {
  return basePath + page;
}
